export enum TickboxMode {
  Dark = 'dark',
  Light = 'light',
}

export interface ITickboxProps {
  /**
   * The text of tickbox
   */
  children: string;
  /**
   * Tickbox is checked or not initially
   */
  checked?: boolean;
  /**
   * Mode to determine colors of text and checkmark
   */
  mode?: TickboxMode;
  /**
   * Use a white background and black checkmark for the tickbox,
   * regardless of mode?
   * PREFERRED in new components, but not default
   */
  whiteBox?: boolean;
  /**
   * Callback called when tickbox change
   */
  onChange?: (checked: boolean) => void;
  /**
   * Data label for tickbox
   */
  dataLabel?: string;
  /**
   * Element is disabled
   */
  disabled?: boolean;
  /**
   * Error message, default is undefined. To show the tickbox
   * in an error state without any text, pass in an empty string.
   */
  error?: string;
}

export interface TickboxLabelProps {
  /**
   * Dark mode or not
   */
  dark: boolean;
  /**
   * Element is disabled
   */
  disabled?: boolean;
}

export interface TickboxInputProps {
  /**
   * Dark mode or not
   */
  dark: boolean;
  /**
   * Use a white background for the tickbox (regardless of mode)
   */
  whiteBox?: boolean;
  /**
   * Element is disabled
   */
  disabled?: boolean;
}

export interface TickboxCheckmarkProps {
  /**
   * Dark mode or not
   */
  dark: boolean;
  /**
   * Element is disabled
   */
  disabled?: boolean;
  /**
   * Display the border of the tickbox in errorstate style
   */
  error?: boolean;
}
